import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, Select } from 'components';
import { AccessoryService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals } from 'utils';
import { CloseIcon } from 'assets/icons';

interface Props {
	title?: string;
	onClose?: any;
	item?: any;
}

class CreateAccessory extends React.Component<Props> {

	state = {
		services: [],
		form: {
			name: '',
			price: '',
			price_corporate: '',
			category_id: ''
		}
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || '',
					price: this.props.item?.price || '',
					price_corporate: this.props.item?.price_corporate || ''
				}
			});
		}

		this.loadServices();
	}

	loadServices = async () => {
		const res: any = await AccessoryService.admin.getServices();
		this.setState({
			services: res.services.map((i: any) => {
				if (this.props.item && this.props.item?.services?.map((i: any) => i.service_id).indexOf(i.id) != -1) {
					i.selected = true;
				}
				return i;
			})
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (this.props.item != null) {
			await AccessoryService.admin.update({
				accessory_id: this.props.item?.id,
				...this.state.form,
				services: JSON.stringify(this.state.services.filter((i: any) => i.selected).map((i: any) => i.id))
			});
			Globals.showSuccess("Se ha modificado el complemento correctamente");
			this.props.onClose();
		}
		else {
			await AccessoryService.admin.create({
				...this.state.form,
				services: JSON.stringify(this.state.services.filter((i: any) => i.selected).map((i: any) => i.id))
			});
			Globals.showSuccess("Se ha creado el complemento correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="create-moderator" className="modal-create-accessory">
				<TitleModalRight
					title={ this.props.title }
					onClose={ this.props.onClose }
				/>
				<form className="container-scroll-modal-right" onSubmit={ this.submit }>
					<div className="row-inputs">
						<div className="row">
							<div className="col-md-12">
								<Input
									color="white"
									value={ this.state.form.name }
									name="name" 
									placeholder="Nombre"
									onChange={ this.change } />
							</div>
							<div className="col-md-6">
								<Input
									type="decimal"
									color="white"
									value={ this.state.form.price }
									label="Precio Detal"
									name="price" 
									placeholder="Precio"
									onChange={ this.change } />
							</div>
							<div className="col-md-6">
								<Input
									type="decimal"
									color="white"
									value={ this.state.form.price_corporate }
									label="Precio Mayor"
									name="price_corporate" 
									placeholder="Precio"
									onChange={ this.change } />
							</div>
							<div className="col-md-12">
								<Select
									label="Categorías a las que aplica"
									name="category_id"
									onChange={ (e: any) => {
										const index = this.state.services.findIndex((i: any) => i.id == e.target.value);
										let services: any = [...this.state.services];
										services[index].selected = true;
										this.setState({
											services
										});
									} }
									value={ this.state.form.category_id }
									options={ this.state.services.filter((i: any) => !i.selected).map((item: any) => {
										return {
											value: item.id,
											label: item.name
										}
									}) } />
							</div>
							{
								this.state.services.filter((i: any) => i.selected).map((i: any) => {
									const index = this.state.services.findIndex((item: any) => item.id == i.id)

									return (
										<div className="col-md-12 row row-selected">
											<div className="col-10">
												<p>{ i.name }</p>
											</div>
											<div className="col-2 text-right">
												<button className="btn-remove" type="button" onClick={ () => {
													let services: any = [...this.state.services];
													services[index].selected = false;
													this.setState({
														services
													});	
												} }>
													<img src={ CloseIcon } />
												</button>
											</div>
										</div>
									)
								})
							}
						</div>
					</div>
					<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default CreateAccessory;